<template>
    <div class="leads" :class="openFilters ? 'openned-filters' : ''">
        <Header :code="code">{{this.projet.nom}}</Header>
        <v-container fluid class="filters" :class="openFilters ? 'openned-filters' : ''">
            <v-row  dense>
                <v-col cols="12 pt-0">
                    <v-select
                        v-model="filterStatus"
                        :items="filterItems"
                        item-text="text"
                        label="Statut"
                        hide-details
                        outlined
                        dense
                        dark
                        clearable
                        return-object
                        @change="filterLeads"
                    ></v-select>
                </v-col>
                <v-col cols="12 pt-0">
                    <v-select
                        v-model="filterSource"
                        :items="filterItemsSource"
                        label="Source d'inscription"
                        hide-details
                        outlined
                        dense
                        dark
                        clearable
                        @change="filterLeads"
                    ></v-select>
                </v-col>
                <v-col cols="12 pt-0">
                    <v-text-field
                        v-model="filterText"
                        outlined
                        clearable
                        dense
                        dark
                        hide-details
                        prepend-inner-icon="mdi-magnify"
                        label="Rechercher (Code, nom ou prénom)"
                        @input="filterLeads"
                    ></v-text-field>
                </v-col>
            </v-row>
            <div class="filterOpen" @click='openFilters = !openFilters'>
                <div>
                    Filtrer 
                    <i class="mdi" :class="openFilters ? 'mdi-chevron-up' : 'mdi-chevron-down'"></i>
                </div>
                <div>
                    {{allLeads.length}} Résultats
                </div>
            </div>
        </v-container>
        <div class="expanse" v-for="lead in allLeads" :key="lead.code_lead" >
            <Lead :lead="lead" :code="code" :mode="'lead'" @reloadLeads="reloadLeads"/> 
        </div>
        <div v-if='allLeads.length == 0' class="mt-6 text-center">
            Vous n'avez pas de leads attribués
        </div>
        <v-btn class="mx-2 btncreate" fab dark depressed small color="primary" @click='$router.push({name:"CreateLead", params: { code: code }})'>
            <v-icon dark>mdi-plus</v-icon>
        </v-btn>
        <Footer01 :code="code"/>
    </div>
</template>
<script>
import Header from '@/components/Header'
import Footer01 from '@/components/Footer01'
import Lead from '@/components/Lead'
export default {
    name: 'Leads',
    props: ['code'],
    components: {
        Header,
        Lead,
        Footer01
    },
    data() {
        return {
            openFilters: false,
            projet: {},
            allLeads: {},
            filterStatus: "",
            filterText: "",
            filterSource: "",
        }
    },
    methods: {
        reloadLeads: function(){
            const allLeads = this.$store.getters.getFilteredLeads(this.filterStatus, this.filterText, this.filterSource)
            this.allLeads =  allLeads.sort((a, b) => (a.finalStatut > b.finalStatut) ? 1 : ((b.finalStatut > a.finalStatut) ? -1 : 0))
        },
        qualifiedLead: function(){
            this.dialog = true
        },
        filterLeads: function() {
            const allLeads = this.$store.getters.getFilteredLeads(this.filterStatus, this.filterText, this.filterSource)
            this.allLeads =  allLeads.sort((a, b) => (a.finalStatut > b.finalStatut) ? 1 : ((b.finalStatut > a.finalStatut) ? -1 : 0))
        }
    },
    computed: {
        filterItemsSource: function() {
            return this.$store.getters.getInscriptionSourceList
        },
        filterItems : function(){
            return this.$store.getters.getStatutList
        }
    },
    watch: {

    },
    created() {
        if(Object.keys(this.$store.state.leads).length === 0) {
            this.$store.dispatch('setLoader', true).then((e) => {
                this.$store.dispatch('getLeadProjets', {codeProjet: this.code}).then((e)=> {
                    this.$store.dispatch('setLoader', false)
                    const allLeads = this.$store.getters.getFilteredLeads(this.filterStatus, this.filterText)
                    this.allLeads =  allLeads.sort((a, b) => (a.finalStatut > b.finalStatut) ? 1 : ((b.finalStatut > a.finalStatut) ? -1 : 0))
                    this.projet = this.$store.state.projets.find((e) => {
                        return e.code_projet == this.code
                    })
                })
            })
        } else {
            this.$store.dispatch('setLoader', false)
             const allLeads = this.$store.getters.getFilteredLeads(this.filterStatus, this.filterText)
             this.allLeads =  allLeads.sort((a, b) => (a.finalStatut > b.finalStatut) ? 1 : ((b.finalStatut > a.finalStatut) ? -1 : 0))
            this.projet = this.$store.state.projets.find((e) => {
                return e.code_projet == this.code
            })
        }
    },
}
</script>
<style lang="scss">
    .btncreate {
        position:fixed;
        bottom:10vh;
        right:2vh;
        z-index:8;
    }
    .leads {
        padding:8vh 0;
        padding-top:12vh;
        transition: padding-top 0.2s ease-in;
        .filters {
            position:relative;
            background-color:#1e2a39;
            position:fixed;
            top:-12vh;
            z-index:4;
            height: 20vh;
            .filterOpen {
                position:absolute;
                background-color:#1e2a39;
                color:white;
                padding:3px 10px;
                width:100%;
                display:flex;
                justify-content: space-between;
                top:100%;
                left:0;
            }
            transition: top 0.2s ease-in;
        }
        .expanse {
            margin-top:5px;
        }
        &.openned-filters {
            padding-top:31vh;
            .filters {
                top:8vh;
                .filterOpen {
                    i {
                        transform: rotate(180deg);
                    }
                }
            }
        }
    }
</style>